<template>
    <router-link v-bind="$attrs" :to="toIncludeCustomerId">
        <slot />
    </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'customer-router-link',
    props: {
        to: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            currentCustomer: 'user/currentCustomer'
        }),
        /**
         * Add the current customer id to the url with a query param.
         *
         * @return {object}
         */
        toIncludeCustomerId() {
            let query = {};

            if (this.currentCustomer) {
                query['customer-id'] = this.currentCustomer.id;
            }

            if (this.to.query) {
                query = {
                    ...query,
                    ...this.to.query
                };
            }

            return {
                ...this.to,
                query
            };
        }
    }
};
</script>
